import { VaultsSection } from '@/components/dashboard/VaultsSection'

export function VaultsPage() {
  return (
    <div style={{ maxWidth: 1280, margin: '0 auto', padding: '24px' }}>
      <VaultsSection />
    </div>
  )
}
